import { createContext } from "react";
import { userState } from "../states/user.state";

const context = createContext(userState);

export default context;
